export const FilterSection = ({
  FilterJalur,
  FilterBentuk,
  FilterStatus,
  FilterJenis,
  ApplyButton,
}) => {
  return (
    <section className="py-4" id="filter-section">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-5">
        {FilterJalur}
        {FilterBentuk}
        {FilterStatus}
        {FilterJenis}
        {ApplyButton}
      </div>
    </section>
  )
}
